module.exports = __webpack_public_path__ + "img/activity_rule.1768119790257.png";